<template>
  <div class="tab-pane fade" id="nav-meters" role="tabpanel" aria-labelledby="nav-meters-tab">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12">
          <div class="row" v-if="meters && meters.length > 0">
            <div class="col-xl-7 mt-3">
              <div class="card">
                <gas-meter v-if="activeServiceType ==='Gas'" />
                <electricity-meter-nhh
                  v-if="activeServiceType=='Electricity' && measurementMethod == 'NonHalfHourly'"
                />
                <electricity-meter-hh
                  v-if="activeServiceType=='Electricity' && measurementMethod == 'HalfHourly'"
                />
              </div>
            </div>
            <div class="col-xl-5 mt-3">
              <div class="meter_history">
                <h3>Meter History</h3>
                <div class="container-fluid">
                  <div class="row">
                    <div class="col-md-12" v-for="(meter, index) in meters" :key="'M' + index">
                      <ul class="timeline" v-if="meter.hasOwnProperty('MeterConfigs')">
                        <li class="timeline-item" v-if="meter.hasOwnProperty('Removed')">
                          <a @click="changeActive(meter, configs(meter)[0])">
                            <div class="timeline-badge pointer"></div>
                          </a>
                          <div class="timeline-panel">
                            <div class="timeline-heading">
                              <p class="font-weight-bold">Meter Removed</p>
                            </div>
                            <div class="timeline-body">
                              <p>{{meter.Removed | shortDate}}</p>
                            </div>
                          </div>
                        </li>
                        <li
                          class="timeline-item"
                          v-for="(config, index) in configs(meter)"
                          :key="'C' + index"
                        >
                          <a @click="changeActive(meter, config)">
                            <div
                              v-if="!meter.hasOwnProperty('Removed')"
                              class="timeline-badge current pointer"
                            ></div>
                            <div v-else class="timeline-badge pointer"></div>
                          </a>
                          <div class="timeline-panel">
                            <div class="timeline-heading">
                              <p class="font-weight-bold">Config Change</p>
                            </div>
                            <div class="timeline-body">
                              <p>{{config.EffectiveFrom | shortDate}}</p>
                            </div>
                          </div>
                        </li>
                        <li class="timeline-item">
                          <a @click="changeActive(meter, configs(meter)[0])">
                            <div
                              v-if="!meter.hasOwnProperty('Removed')"
                              class="timeline-badge current pointer"
                            ></div>
                            <div v-else class="timeline-badge pointer"></div>
                          </a>
                          <div class="timeline-panel">
                            <div class="timeline-heading">
                              <p class="font-weight-bold">Meter Installed</p>
                            </div>
                            <p></p>
                            <p v-if="meter.Installed">{{meter.Installed | shortDate}}</p>
                            <div class="timeline-body"></div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row" v-else>
            <div class="row">
              <div class="col-12">
                <div class="h-100">
                  <div class="d-flex h-100 justify-content-center align-items-center">
                    <img
                      src="@/assets/img/warning_icon.png"
                      class="img-fluid d-inline-block"
                      alt="No charges have been applied to this account"
                    />
                    <p
                      class="d-inline-block my-auto pl-2"
                    >No meter information available at this time.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gasMeter from "./components/GasMeter";
import electricityMeterNhh from "./components/ElectricityMeterNhh";
import electricityMeterHh from "./components/ElectricityMeterHh";

import _filters from '@/mixins/filters'

export default {
  name: 'meters',
  mixins: [_filters],
  components: {
    gasMeter,
    electricityMeterNhh,
    electricityMeterHh
  },
  data() {
    return {
      index: null
    };
  },
  methods: {
    changeActive(meter, config) {
      this.$store.dispatch("changeActiveMeterInfo", meter);
      this.$store.dispatch("changeActiveConfigInfo", config);
    },
    configs(meter) {
      return this.$_.sortBy(meter.MeterConfigs, "EffectiveFrom").reverse();
    },
  },
  computed: {
    activeServiceType() {
      return this.$store.state.meters.activeService.Service.ServiceType;
    },
    meters() {
      if (this.$store.state.meters.activeService) {
        return this.$store.state.meters.activeService.Meters.slice().reverse();
      }
    },
    measurementMethod() {
      return this.$_.sortBy(
        this.$store.state.meters.activeService.MeterPoint.MeterPointConfigs,
        "EffectiveFrom"
      ).reverse()[0].MeasurementMethod;
    }
  }
};
</script>

<style lang="css" scoped>
.link {
  color: blue;
  text-decoration: underline;
}
</style>